import styled from 'styled-components/macro'
import { Overlay, Thread } from 'styles/misc'
import { Title as TitleBase } from 'components/misc'
import { SlideProps } from 'components/slider/styled'
import { mq } from 'styles/mq'
import { Container } from 'components/container'

export const Title = styled(TitleBase)`
  &::before {
    ${Thread}
    top: -1.5em;
    width: 100%;
    aspect-ratio: 1440 / 760;
    mask-image: url("data:image/svg+xml,%3Csvg width='1440' height='760' viewBox='0 0 1440 760' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M-202.54 288.83C-143.54 154.14 -22.52 48.14 118.77 7.38997C143.85 0.159968 172.8 -4.57003 194.49 9.95997C218.04 25.73 223.54 60.05 212.88 86.31C202.22 112.57 179.04 131.74 154.58 146.05C148.79 149.44 141.87 152.71 135.62 150.26C125.21 146.19 126.06 131.18 129.86 120.67C148.53 69.01 194.63 28.18 248.17 15.87C301.71 3.56997 361 20.18 400.36 58.51C431.73 89.06 449.67 130.73 463.07 172.41C493.25 266.31 504.69 366.95 549.66 454.74C619.7 591.47 762.61 677.95 909.99 721.29C1186.75 802.68 1499.95 748.76 1733.55 579.5' stroke='white' vector-effect='non-scaling-stroke' stroke-width='1.5' stroke-miterlimit='10'/%3E%3C/svg%3E%0A");
  }
`

export const SlideImage = styled.img<SlideProps>`
  display: block;
  width: 70vw;
  aspect-ratio: ${props => props.aspectRatio};
  object-fit: cover;
  cursor: pointer;

  ${mq.medium} {
    width: 100%;
  }
`

export const ActiveSlideImage = styled.img`
  ${Overlay}
  opacity: 1;
  transition: 1s mask;
  mask-image: linear-gradient(
    to bottom,
    transparent,
    transparent,
    black,
    black
  );
  mask-size: 100% 300%;

  .swiper-slide-active & {
    mask-position: 0 100%;
  }
`

export const StyledContainer = styled(Container)`
  ${mq.smallOnly} {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`
